import $ from 'jquery';

var diff,
    elHeight,
    doParalax = true;

/*
At the moment I use translateY to move object.
This will be changed if issues appear.
*/
$(document).ready(function() {
    if (document.getElementById('video')) {
        elHeight = $("#video").outerHeight();
        document.querySelector("#video > .csc-element").style.transform = "translateY(0)";
    }
});

// on load & resize check if object in viewport & decide if parallax will appear
$(window).on('DOMContentLoaded load resize', function() {
    if (document.getElementById('video')) {
        doParalax = $("#video").inViewport() ? false : true;
    }
});


$(window).on('resize scroll', function(e) {
    // get diff. between current scroll position and parallax object top position
    if (!document.getElementById('video')) {
        return;
    }
    
    diff = $("#video").offset().top - $(window).scrollTop();

    // on resize, if object in viewport, don't do parallax
    if(e.type === 'resize' && $("#video").inViewport()) {
        document.querySelector("#video > .csc-element").style.transform = "translateY(0)";
    } else {
        if($("#video").inViewport() && doParalax) {
            if(diff >= 0) {
                if ($(window).width() < 768) diff -= $(window).width() / 2;
                // if ($(window).width() < 1024) diff -= $(window).width() / 2;
                document.querySelector("#video > .csc-element").style.transform = "translateY(-"+diff+"px)";
            } else {
                document.querySelector("#video > .csc-element").style.transform = "translateY(0)";
            }
        }
    }
});

// old way to check if object in viewport, for older browsers support
$.fn.inViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
